import React, { FC, memo, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { disabledMenuSwipeClass } from '@hkm/components/Menu/MenuContainer';
import DashboardQuickFilterItem from '@hkm/components/TaskManagement/Dashboard/DashboardSubheader/DashboardQuickFilterWrapper/DashboardQuickFilterItem/DashboardQuickFilterItem';
import { getDashboardQuickFilter } from '@hkm/components/TaskManagement/Dashboard/domain/selectors';
import { useTaskDashboardManager } from '@hkm/components/TaskManagement/Dashboard/useTaskDashboardManager';
import { TaskQuickFilter } from '@hkm/components/TaskManagement/domain/enums/TaskQuickFilter';
import { quickFilters } from '@hkm/components/TaskManagement/mappers';
import classNames from 'classnames';
import i18next from 'i18next';

import { AcFlex } from '@ac/mobile-components/dist/components/flex';

const DashboardQuickFilterWrapper: FC = () => {
  const { updateQuickFilter } = useTaskDashboardManager();
  const quickFilter = useSelector(getDashboardQuickFilter);
  const className = classNames('quick-filter', disabledMenuSwipeClass);

  const quickFiltersOptions = useMemo(() => quickFilters(i18next), []);

  const applyQuickFilter = useCallback(
    (filter: TaskQuickFilter) => {
      const currentFilter = quickFilter !== filter ? filter : undefined;
      updateQuickFilter(quickFilter, currentFilter);
    },
    [quickFilter]
  );

  return (
    <div className={className}>
      <AcFlex className="quick-filter-scroll">
        {quickFiltersOptions.map((quickFilterItem, index) => (
          <DashboardQuickFilterItem
            key={`${quickFilterItem.value}-${index}`}
            quickFilter={quickFilterItem}
            appliedQuickFilter={quickFilter}
            applyQuickFilter={applyQuickFilter}
          />
        ))}
      </AcFlex>
    </div>
  );
};

export default memo(DashboardQuickFilterWrapper);



// WEBPACK FOOTER //
// ./src/components/TaskManagement/Dashboard/DashboardSubheader/DashboardQuickFilterWrapper/DashboardQuickFilterWrapper.tsx